import { HomeInner, HomeWrapper } from "./styles";
import HomeHeader from "./components/header";
import UserCard from "./components/user-card";
import { userState } from "../../../recoil/auth";
import { useRecoilState, useRecoilValue } from "recoil";
import HomeTab from "./components/home-tab";
import { useEffect, useState } from "react";
import AdBanner from "./components/ad-banner";
import HomeYoutube from "./components/youtube";
import HomeFranchiseBanner from "./components/franchise-banner";

// 커스텀 훅들 import
import useAppUpdate from "./hooks/use-app-update";
import usePushNotification from "./hooks/use-push-notification";
import usePopupNotice from "./hooks/use-popup-notice";
import useLocationSetup from "./hooks/use-location-setup";
import { isApp } from "../../../hooks/useNativeApp";
import PopupNotice from "../../../components/common/PopupNotice";
import VideoPopup from "./components/video-popup/video-popup";
import UserCardSkeleton from "./components/user-card/skeleton";
import { videoPopupState } from "../../../recoil/video-popup";
import { userLoadingState } from "../../../recoil/user-loading";
import useQr from "./hooks/use-qr";
import QrPage from "./components/qr-page";

const RenewalHome = () => {
  const user = useRecoilValue(userState);
  const [isUserCardLoading, setIsUserCardLoading] =
    useRecoilState(userLoadingState);
  // 커스텀 훅
  const { latitude, longitude } = useLocationSetup(); //위치 관련 훅
  const { checkAppUpdate } = useAppUpdate(); //앱 업데이트 훅
  const { debouncedRegisterPushInfo } = usePushNotification(
    latitude,
    longitude,
  );
  const [isVideoPopupOpen, setIsVideoPopupOpen] =
    useRecoilState(videoPopupState);
  const { popupNoticeData, setPopupNoticeData } = usePopupNotice();
  const { isQrOpen, setIsQrOpen, qrValue, getRemainingSeconds } = useQr();

  useEffect(() => {
    setTimeout(() => {
      setIsUserCardLoading(false);
    }, 250);
  }, []);

  useEffect(() => {
    const currentUrl = new URL(window.location.href);

    if (isQrOpen) {
      // QR 페이지가 열릴 때 ?page=qr 추가
      currentUrl.searchParams.set("page", "qr");
      // 히스토리에 새 항목 추가 (뒤로가기 가능하도록)
      window.history.pushState({}, "", currentUrl.toString());
    } else {
      // QR 페이지가 닫힐 때 page 파라미터 제거
      currentUrl.searchParams.delete("page");
      // URL 업데이트 (페이지 새로고침 없이)
      window.history.replaceState({}, "", currentUrl.toString());
    }
  }, [isQrOpen]);

  // 뒤로가기 버튼 이벤트 처리
  useEffect(() => {
    const handlePopState = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const pageParam = urlParams.get("page");

      if (isQrOpen && pageParam !== "qr") {
        setIsQrOpen(false);
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isQrOpen, setIsQrOpen]);

  // 푸시 알림 등록
  useEffect(() => {
    if (user) {
      debouncedRegisterPushInfo();
    }
  }, [latitude, user, debouncedRegisterPushInfo]);

  // 앱 체크
  useEffect(() => {
    if (isApp) {
      checkAppUpdate();
    }
  }, [checkAppUpdate]);

  return (
    <HomeWrapper>
      {popupNoticeData.length > 0 && (
        <PopupNotice
          data={popupNoticeData[0]}
          onClose={() => {
            setPopupNoticeData(popupNoticeData.slice(1));
          }}
        />
      )}
      <HomeInner>
        <HomeHeader loading={isUserCardLoading} /> {/* 메인 화면 헤더 */}
        {isUserCardLoading && <UserCardSkeleton />}
        {user && (
          <UserCard
            loading={isUserCardLoading}
            isQrOpen={isQrOpen}
            setIsQrOpen={setIsQrOpen}
            qrValue={qrValue}
          />
        )}
        {/* 지갑 및 개인 정보 카드 */}
        <HomeTab /> {/* 홈 탭 */}
        <AdBanner /> {/* 광고 배너 */}
        <HomeYoutube /> {/* 유튜브 / 유튜브 채널*/}
        <HomeFranchiseBanner /> {/* 가맹 배너 */}
      </HomeInner>
      {isVideoPopupOpen && (
        <VideoPopup setIsVideoPopupOpen={setIsVideoPopupOpen} />
      )}
      {isQrOpen && user && (
        <QrPage
          qrValue={qrValue}
          getRemainingSeconds={getRemainingSeconds}
          setIsQrOpen={setIsQrOpen}
          user={user}
        />
      )}
    </HomeWrapper>
  );
};

export default RenewalHome;
